








































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { UpdateActivity } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import { VImageUpload } from '@/components/upload'
import constan from '@/utils/constant'

@Component({
  components: { VImageUpload },
})
export default class UpdateActivityDialog extends Vue {
  private show = false
  private data: any = {
    activityType: 0,
    activityLabel: '限时抢购',
    activityImgList: [],
    activityImg: '',
    maxQty: 0,
    activityBannerImg: '',
    activityBannerImgList: [],
    zoneDistributionFlag: 0
  }
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    activityName: [this.requiredRule],
    startTime: [this.requiredRule],
    endTime: [this.requiredRule],
  }
  private activityType = constan.GoodsActivityType

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
    this.data = {
      activityType: 0,
      activityLabel: '限时抢购',
      activityImgList: [],
      activityImg: '',
      maxQty: 0,
      activityBannerImg: '',
      activityBannerImgList: []
    }
  }
  public open(data: any) {
    this.show = true
    this.data = { ...data, zoneDistributionFlag: data.zoneDistributionFlag != null ? data.zoneDistributionFlag : 0 }
    if(this.data.activityImg){
      this.data.activityImgList = this.data.activityImg.split(',').map((e: string) => {return {url:e}})
    }else{
      this.data.activityImgList = []
    }
    if(this.data.activityBannerImg){
      this.data.activityBannerImgList  = this.data.activityBannerImg.split(',').map((e: string) => {return {url:e}})
    }else{
      this.data.activityBannerImgList = []
    }
    console.log(this.data.activityBannerImgList)
  }

  public async save() {
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }
      this.data.activityImg = this.data.activityImgList.map((e: any) => e.url).join(',')
      this.data.activityBannerImg = this.data.activityBannerImgList.map((e: any) => e.url).join(',')
      await UpdateActivity(this.data)
      Message.success('保存')
      this.close()
    })
  }
}
